import { BookCancelConfirmDialogComponent } from './../../../book/book-cancel-confirm-dialog/book-cancel-confirm-dialog.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';


@Component({
  selector: 'app-popup-user',
  templateUrl: './popup-user.component.html',
  styleUrls: ['./popup-user.component.scss']
})
export class PopupUserComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public element: any,
    private dialogRef: MatDialogRef<BookCancelConfirmDialogComponent>) {
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

}